
const useBasic = ({ formik,basicData, storeState, setStoreState }) => {

  const getMinEndDate = () => {
    const startDate = formik?.values?.start_date;
    if (!startDate) return "";
    const date = new Date(startDate);
    date.setDate(date.getDate()); // Add one day
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };
  const getMaxDate = () => {
    const endDate = formik?.values?.end_date;
    if (!endDate) return "";
    const date = new Date(endDate);
    date.setDate(date.getDate());
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const handleTypeChange = (selectedOptions) => {
    formik?.setFieldValue("store", selectedOptions);
  };
  const handleNext = () => {
    setStoreState((prev) => ({
      ...prev,
      activeTab: "Store Hours",
    }));
  };
  const handleCloseModal = () => {
    setStoreState((prev) => ({
      ...prev,
      isEdit: false,
      showCreateModal: !prev.showCreateModal,
    }));
  };

  const handleAddSelectedEmail = () => {
    if (formik?.values?.emails !== "" && !formik?.errors?.emails) {
      if (!formik?.values?.selected_emails?.includes(formik?.values?.emails)) {
        formik.setFieldValue("selected_emails", [
          ...formik.values.selected_emails,
          formik?.values?.emails,
        ]);
        formik.setFieldValue("emails", "");
      } else {
        formik.setFieldError("emails", "Email is already added");
      }
    }
  };

  const handleRemoveSelectedEmail = (index) => {
    if (index > -1 && index < formik?.values?.selected_emails.length) {
      const updatedEmails = [...formik.values.selected_emails];
      updatedEmails.splice(index, 1);

      formik.setFieldValue("selected_emails", updatedEmails);
    }
  };

  return {
    handleNext,
    handleCloseModal,
    basicData,
    handleTypeChange,
    getMinEndDate,
    getMaxDate,
    handleAddSelectedEmail,
    handleRemoveSelectedEmail,
  };
};

export default useBasic;
